import React from "react"
import PropTypes from 'prop-types'

const Card = (props) => {
    const { 
        data: { 
            photoUrl, 
            location, 
            firstName, 
            lastName, 
            fullName, 
            profileLink, 
            profileText, 
            company 
        }
    } = props

    return (
        <tm-trailblazer-item
            key={`mvp-card-${fullName}`}
            name={`${firstName} ${lastName}`}
            location={location} 
            img-src={photoUrl}
            img-alt={`${firstName} ${lastName} portrait`}
            role={company}
            rank={"Trailblazer Community Forum Ambassador"}
            profile-href={profileLink} 
            profile-title={profileText} />
    )
}

Card.propTypes = {
    data: PropTypes.object.isRequired
}

export default Card